import { cloneDeep, isEqual, xorWith } from 'lodash';

export function cloneObject<T>(obj: T): T {
    return cloneDeep(obj);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isArrayEqual(first: any[], second: any[]) {
    if (!Array.isArray(first) || !Array.isArray(second)) return false;
    if (first.length === 0 && second.length === 0) return true;
    if (first.length !== second.length) return false;

    return xorWith(first, second, isEqual).length === 0;
}

export function isObjectEqual(first: object, second: object) {
    if (typeof first !== 'object' || first === null) return false;
    if (typeof second !== 'object' || second === null) return false;

    if (Object.keys(first).length === 0 && Object.keys(second).length === 0) return true;
    if (Object.keys(first).length !== Object.keys(second).length) return false;

    return isEqual(first, second);
}

export function jsonize<T>(str: string, strict?: false): T | string;
export function jsonize<T>(str: string, strict: true): T | null;
export function jsonize<T>(str: string, strict?: boolean): T | null | string {
    const strDefault = strict ? null : str;

    if (typeof str !== 'string') return strDefault;

    let strJson;
    try {
        strJson = JSON.parse(str);
    } catch {
        return strDefault;
    }

    return strJson as T;
}

export function uniqueArray<T>(array: T[] | Array<T | undefined>) {
    return [...new Set((array?.filter((v) => v !== undefined) as NonNullable<T>[]) ?? []).values()];
}

export function arraySortByValues<T extends string | number>(array: T[], sortValues?: T[]): T[] {
    if (!array || array.length === 0) {
        return array;
    }

    return array.sort((valueA, valueB) => {
        if (valueA === undefined || valueB === undefined) {
            return valueA === undefined && valueB === undefined ? 0 : valueB === undefined ? -1 : 1;
        }

        const indexA = !sortValues || sortValues.length === 0 ? -1 : sortValues.indexOf(valueA);
        const indexB = !sortValues || sortValues.length === 0 ? -1 : sortValues.indexOf(valueB);

        if (indexA === -1 && indexB === -1) {
            return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        }

        if (indexA === -1 || indexB === -1) {
            return indexB === -1 ? -1 : 1;
        }

        return indexA > indexB ? 1 : indexA < indexB ? -1 : 0;
    });
}
